import { Either } from 'purify-ts';
import { Paginated } from '../conversations/types';
import { TemplatesRepositoryFailure } from './failure';
import {
  CreateTemplateProps,
  CreatedTemplate,
  DeleteTemplateProps,
  ListTemplatesOptions,
  Template,
} from './types';

export abstract class ITemplatesRepository {
  public abstract getList(
    options: ListTemplatesOptions
  ): Promise<Either<TemplatesRepositoryFailure, Paginated<Template>>>;

  public abstract create(
    props: CreateTemplateProps
  ): Promise<Either<TemplatesRepositoryFailure, CreatedTemplate>>;

  public abstract remove(
    props: DeleteTemplateProps
  ): Promise<Either<TemplatesRepositoryFailure, void>>;
}
